import { SvgIconBase, } from "./Base";


export const Bars = () => {
	return (
		<SvgIconBase width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-label="Bars" fill="currentColor">
			<title>Bars</title>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.66732 4.0835C7.08153 4.0835 7.41732 3.74771 7.41732 3.3335C7.41732 2.91928 7.08153 2.5835 6.66732 2.5835L4.83398 2.5835C3.59134 2.5835 2.58398 3.59085 2.58398 4.83349L2.58398 15.1668C2.58398 16.4095 3.59134 17.4168 4.83398 17.4168H6.66732C7.08153 17.4168 7.41732 17.081 7.41732 16.6668C7.41732 16.2526 7.08153 15.9168 6.66732 15.9168H4.83398C4.41977 15.9168 4.08398 15.581 4.08398 15.1668L4.08398 4.83349C4.08398 4.41928 4.41977 4.0835 4.83398 4.0835L6.66732 4.0835ZM13.334 4.0835C12.9198 4.0835 12.584 3.74771 12.584 3.3335C12.584 2.91928 12.9198 2.5835 13.334 2.5835L15.1673 2.5835C16.41 2.5835 17.4173 3.59085 17.4173 4.83349V15.1668C17.4173 16.4095 16.41 17.4168 15.1673 17.4168H13.334C12.9198 17.4168 12.584 17.081 12.584 16.6668C12.584 16.2526 12.9198 15.9168 13.334 15.9168H15.1673C15.5815 15.9168 15.9173 15.581 15.9173 15.1668V4.83349C15.9173 4.41928 15.5815 4.0835 15.1673 4.0835L13.334 4.0835Z"
			/>
		</SvgIconBase>
	);
};

